import React from 'react';
import {
  IconBook,
  IconCalendar,
  IconClock,
  IconHelp,
  IconMail,
  IconMapPin,
  IconSparkles,
  IconUser,
} from '@tabler/icons-react';
import { FloatingCornerMenu } from './ui';
import type { FloatingCornerMenuItem, FloatingCornerMenuSection } from './ui';
import { useUser } from '../src/context/UserContext';
import { usePendingCount } from '../src/hooks/usePendingCount';

const HELP_ITEMS: FloatingCornerMenuItem[] = [
  { icon: IconMail, label: 'Contact Us', href: '/contact' },
  { icon: IconHelp, label: 'FAQ', href: '/help#quick-answers' },
  { icon: IconSparkles, label: "What's New", href: '/updates' },
  { icon: IconBook, label: 'Help Center', href: 'https://help.wherecanwedance.com', external: true },
];

const ADD_ITEMS: FloatingCornerMenuItem[] = [
  { icon: IconUser, label: 'Add Artist', href: '/artists/new' },
  { icon: IconCalendar, label: 'Add Event', href: '/events/new' },
];

// Help for everyone; SuperAdmins and Editors also get their quick actions
// above it, in the same button (#1910).
const FloatingHelpMenu = () => {
  const { user } = useUser();
  const isSuperAdmin = user?.roles?.includes('SuperAdmin') ?? false;
  const isEditor = user?.roles?.includes('Editor') ?? false;
  const pendingCount = usePendingCount(isSuperAdmin);

  const sections: FloatingCornerMenuSection[] = [];
  if (isSuperAdmin) {
    sections.push({
      title: 'Admin',
      items: [
        { icon: IconClock, label: 'Pending Approvals', href: '/admin?tab=review&sub=pending', count: pendingCount },
        ...ADD_ITEMS,
        { icon: IconMapPin, label: 'Manage Locations', href: '/admin?tab=directory&sub=locations' },
        { icon: IconBook, label: 'Manage Glossary', href: '/admin?tab=directory&sub=dictionary' },
      ],
    });
  } else if (isEditor) {
    sections.push({ title: 'Editor', items: ADD_ITEMS });
  }
  sections.push({ title: sections.length > 0 ? 'Help' : undefined, items: HELP_ITEMS });

  const hasQuickActions = isSuperAdmin || isEditor;
  const baseLabel = hasQuickActions ? 'Help and quick actions' : 'Help and contact';
  const triggerLabel = pendingCount > 0 ? `${baseLabel}, ${pendingCount} pending` : baseLabel;

  return <FloatingCornerMenu sections={sections} triggerLabel={triggerLabel} badgeCount={pendingCount} />;
};

export default FloatingHelpMenu;
